import {
  WappSession,
  isWappConnected,
  getWappSessions,
} from 'weblite-web-wapprunner'
import { Event, Meta, Response, WappMode } from '@weblite-wapps/protocol'
import { getWappDOMElement, postMessage } from './helper/common.helper'
import { addPendingEventToSend } from './helper/pending-events-to-send'

const considerConnectionWappIds = [
  'jaryan-kooleh',
  'jaryan-jaryan',
  'rahkar-rahkar-main',
]

const shouldConsiderConnection = (meta: Meta) => {
  const { wappId } = meta
  return (
    meta.mode === WappMode.STATIC && considerConnectionWappIds.includes(wappId)
  )
}

export const sendActionToWapp = async <P>(action: Event<P> | Response<P>) => {
  const element = await getWappDOMElement(action.meta!)
  if (element) postMessage(element, action)
}

export function sendEventToWapp<P>(event: Event<P>) {
  if (
    !shouldConsiderConnection(event.meta!) ||
    isWappConnected(event.meta!.wappSessionId)
  )
    sendActionToWapp<P>(event)
  else addPendingEventToSend(event)
}

export function sendEventToAllWapps<P>(
  eventFactoryBySession: (session: WappSession) => Event<P>,
) {
  const sessions = getWappSessions()
  sessions.forEach(session => sendEventToWapp(eventFactoryBySession(session)))
}

export function sendResponseToWapp<P>(response: Response<P>) {
  return sendActionToWapp<P>(response)
}
